import Color from 'color';

const white = Color('white');
const black = Color('black');

export default theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ color }) => Color(theme.palette[color].main).mix(white, 0.7).string(),
    border: ({ color }) =>
      `1px solid ${Color(theme.palette[color].main).mix(white, 0.7).string()}`,
    boxShadow: '0 .25rem .75rem rgba(0,0,0,.1)',
    borderRadius: '.25rem',
    padding: '1rem 1.5rem',
    marginBottom: '.5rem',
    color: ({ color }) => Color(theme.palette[color].main).mix(black, 0.3).string(),
    '& span': {
      marginLeft: '1rem'
    }
  }
});
